import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-control_url",
  "use": "icon-control_url-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-control_url\"><g transform=\"translate(-307 -270)\" stroke=\"currentColor\" fill=\"transparent\"><circle cx=\"318\" cy=\"282\" r=\"1.5\" /><circle cx=\"318\" cy=\"274\" r=\"1.5\" /><circle cx=\"311\" cy=\"278\" r=\"1.5\" /><path d=\"M316.729 274.726l-4.462 2.55M312.424 278.814l4.302 2.458\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol